<template>
  <div class="d-flex align-items-center">
    <span class="mr-2">{{ label }}</span>

    <b-dropdown
        size="sm"
        :variant="dropdownVariant"
        toggle-class="py-0 px-1"
        no-caret
        auto-close="outside"

        :right="false"  
        :dropleft="dropComputed === 'left'"
        :dropright="dropComputed === 'right'"
        :dropup="dropComputed === 'up'"

        boundary="window"
        :popper-opts="popperOptsV1"  

        :offset="offset"
        :menu-class="['cec-filter-menu']"
        @shown="handleDropdownShown"
      >
      <template #button-content>
        <i class="fa fa-ellipsis-h"></i>
      </template>

      <!-- Busca -->
      <b-form-input
        ref="searchInput"
        v-model="query"
        size="sm"
        :placeholder="placeholder"
        class="p-2 mt-1 w-100"
        @keydown.stop
      />

      <!-- Selecionar todos -->
      <b-form-checkbox
        :checked="selectAll"
        @change="toggleSelectAll"
        class="ml-3 mb-2"
      >
        (Selecionar todos)
      </b-form-checkbox>

      <!-- Opções -->
      <div class="px-3 pb-2 cec-filter-scroll">
        <b-form-checkbox-group
          v-model="internalValue"
          :options="filteredOptions"
          stacked
          @change="emitChange"
        />
      </div>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: 'SetFilter',
  props: {
    label: { type: String, required: true },
    value: { type: Array, default: () => [] },
    options: { type: Array, required: true },              // [{value, text}]
    normalizeFn: { type: Function, default: s => String(s).normalize('NFD').replace(/\p{Diacritic}/gu,'').toLowerCase() },
    placeholder: { type: String, default: 'Filtrar valores...' },
    dropdownVariant: { type: String, default: 'outline-secondary' },

    /* >>> NOVO: controle de direção/alinhamento */
    align: { type: String, default: 'auto' },              // 'left' | 'right' | 'auto'
    drop:  { type: String, default: 'down' },              // 'down' | 'up' | 'left' | 'right'
    offset: { type: [String, Number], default: 6 },        // espaçamento Popper
    menuClass: { type: [String, Array, Object], default: '' } // classes extras no menu (opcional)
  },
  data(){ return { query:'', internalValue:[...(this.value||[])] } },
  computed:{
    selectAll(){ return this.internalValue.length>0 && this.internalValue.length===this.options.length },
    filteredOptions(){
      if(!this.query) return this.options
      const q = this.normalizeFn(this.query)
      return this.options.filter(o => this.normalizeFn(o.text).includes(q))
    },

    dropComputed () {
      const d = (this.drop || 'down').toLowerCase()
      return ['up','left','right'].includes(d) ? d : 'down'
    },
    alignComputed () {
      if (this.align !== 'auto') return this.align === 'right' ? 'right' : 'left'
      // heurística: decide pelo espaço disponível
      const th = this.$el && this.$el.closest && this.$el.closest('th')
      if (!th) return 'left'
      const r = th.getBoundingClientRect()
      const menuW = 320   // largura média do menu
      const spaceLeft  = r.left
      const spaceRight = window.innerWidth - r.right
      return (spaceRight < menuW && spaceLeft > spaceRight) ? 'right' : 'left'
    },

    // 🔴 Popper v1 com placement correto
    popperOptsV1 () {
      // mapeia drop + align => placement do Popper
      const side =
        this.dropComputed === 'up'    ? 'top' :
        this.dropComputed === 'left'  ? 'left' :
        this.dropComputed === 'right' ? 'right' : 'bottom'

      const edge = (this.alignComputed === 'right') ? 'end' : 'start'
      const placement = `${side}-${edge}` // ex.: 'bottom-end', 'top-start', etc.

      return {
        positionFixed: true,
        placement, // <- ESSENCIAL
        modifiers: {
          preventOverflow: { boundariesElement: 'window', padding: 8 },
          flip:            { boundariesElement: 'window', padding: 8 }
        }
      }
    }
  },
  watch:{ value(v){ this.internalValue = [...(v||[])] } },
  methods:{
    handleDropdownShown() {
      // Pequeno delay para garantir que o DOM esteja renderizado
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.searchInput) {
            this.$refs.searchInput.focus()
          }
        }, 50)
      })
    },
    emitChange(){ this.$emit('input',[...this.internalValue]); this.$emit('change',[...this.internalValue]) },
    toggleSelectAll(on){ this.internalValue = on ? this.options.map(o=>o.value) : []; this.emitChange() }
  }
}
</script>

<style>

/* sobrepõe overlays comuns e continua abaixo de modais */
.cec-filter-menu { z-index: 2050; min-width: 260px; max-width: 420px; }

/* somente a lista rola; altura baseada na viewport, não na tabela */
.cec-filter-menu .b-dropdown-form,
.cec-filter-menu .cec-filter-scroll { max-height: 65vh; overflow-y: auto; overflow-x: hidden; }
</style>



// WEBPACK FOOTER //
// src/components/Cec/SetFilter.vue